import { RouteObject } from 'react-router-dom';

import { MESSAGES_ROUTES } from './messages.constants';

export const messagesRoutes = [
  {
    path: MESSAGES_ROUTES.MESSAGES,
    lazy: async () => ({
      Component: (await import('./MessagesPage')).MessagesPage,
    }),
  },
  {
    path: MESSAGES_ROUTES.NEW_MESSAGE,
    lazy: async () => ({
      Component: (await import('./NewMessagePage/NewMessagePage'))
        .NewMessagePage,
    }),
  },
  {
    path: MESSAGES_ROUTES.NEW_MESSAGE_SUB_PAGE,
    lazy: async () => ({
      Component: (await import('./NewMessagePage/NewMessageSubPage'))
        .NewMessageSubPage,
    }),
  },
  {
    path: MESSAGES_ROUTES.SINGLE_MESSAGE_THREAD,
    lazy: async () => ({
      Component: (await import('./SingleMessageThreadPage'))
        .SingleMessageThreadPage,
    }),
  },
  {
    path: MESSAGES_ROUTES.NOTICE_PAGE,
    lazy: async () => ({
      Component: (await import('./NoticePage/NoticePage')).NoticePage,
    }),
  },
] satisfies RouteObject[];
